import React from 'react';
import Top from './Top';
import { cognitoConstants } from "./constants/aws";

import { Amplify } from 'aws-amplify';
Amplify.configure(cognitoConstants);

import { withAuthenticator, Greetings, SignUp } from 'amplify-material-ui';

function App() {
  return (
    <Top/>
  )
}

export default withAuthenticator(App, {
  hide: [Greetings, SignUp],
  hideSignUpLink: true,
  hideForgotPasswordLink: true,
});
